import { ShipmentsApiAdapter } from '../adapters/ShipmentsApiAdapter';
import { Shipment, BlockedShipmentsPage } from '../models/Shipments';
import { Filters } from '../models/Filters';

export interface ShipmentsPage {
  shipments: Shipment[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class ShipmentsService {
  constructor(private apiAdapter: ShipmentsApiAdapter) {}

  async getAllShipments(filters: Filters = {}): Promise<Shipment[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedShipments(filters: Filters = {}): Promise<ShipmentsPage> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getShipmentsPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<ShipmentsPage> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getShipmentsPaginated(filters);
  }

  async getBlockedShipmentsPaginated(filters: Filters = {}): Promise<BlockedShipmentsPage> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getBlockedShipmentsPaginated(filters);
  }
}

